import { defineMessages } from 'react-intl';

export const projectScrollToBottomButtonMessages = defineMessages({
  label: {
    defaultMessage: 'Scroll to bottom',
    id: 'ffOJIgcjMj',
    description:
      'Accessible label for the Work chat button that jumps to the newest content in the transcript',
  },
});
